<template>
  <div class="row w-100 max-w-xl mx-auto">
    <!-- 麥克風測試 -->
    <div class="col-6 col-lg-12 p-2">
      <div class="border h-100 d-flex flex-column justify-content-between align-items-center rounded position-relative border_main11">
        <div class="p-2 w-100 bg-blue-lighter-toeic">
          <p class="fw-bold text-white text-center text-lg mb-0">麥克風測試</p>
        </div>
        <div class="item_img p-2 mb-1 d-flex justify-content-center">
          <div class="p-2 pointer" @click="toggleRecord">
            <div class="record_img">
              <canvas id="canvas" ref="recordRefTest" class="canvas canvas_test"></canvas>
            </div>
          </div>
        </div>
        <div class="p-3">
          <p class="gept_main_color text-center fw-semibold mb-0 text-base">
            請對著麥克風說話，線條產生波動，代表麥克風正常。
          </p>
        </div>
      </div>
    </div>
    <!-- 音檔播放測試 -->
    <div class="col-6 col-lg-12 p-2">
      <div class="border h-100 d-flex flex-column justify-content-between align-items-center rounded position-relative border_main11">
        <div class="p-2 w-100 bg-blue-lighter-toeic">
          <p class="fw-bold text-white text-center text-lg mb-0">音檔播放測試</p>
        </div>
        <div class="item_img p-2 mb-1 pointer">
          <!-- <div> -->
            <img
              src="@/assets//image/toeic/toeic_exam/play_test.png"
              alt=""
              v-if="!isPlayingAudio"
              @click="audio_play"
              class="w-100 object-contain"
            />
            <img
              src="@/assets//image/toeic/toeic_exam/play_test_on.png"
              alt=""
              v-else
              @click="audio_stop"
              class="w-100 object-contain"
            />
          <!-- </div> -->
        </div>
        <div class="p-3">
          <p class="gept_main_color text-center fw-semibold mb-0 text-base">
            請點選播放後，確認聲音播放是否正常。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Recorder from 'js-audio-recorder'
let recorderJS = new Recorder()
export default {
  name: 'TestingTools',
  props: {
  },
  data () {
    return {
      audioData: null,
      sound_effect: null,

      isPlayingAudio: false,
      isRecording: false
    }
  },
  computed: {
  },
  watch: {
  },
  mounted () {
    this.setAudio()

    navigator.mediaDevices.getUserMedia({ audio: true })

    this.setTimeoutFun()
  },
  beforeDestroy () {
    if (this.isPlayingAudio || this.sound_effect && this.sound_effect.currentTime > 0) {
      this.audio_stop()
    }
    if (this.isRecording) {
      this.stopRecord()
    }
  },
  methods: {
    cleanTimeOut () {
      let self = this
      clearTimeout(self.timeOutProcessId)
    },
    setTimeoutFun () {
      let self = this
      self.timeOutProcessId = setTimeout(() => {
        self.toggleRecord()
      }, 1000)
    },
    // 播放測試
    setAudio () {
      const audioMap = {
        TOEIC_exam: '/toeic.mp3',
        default: '/Bridge.mp3'
      }

      const src = audioMap[this.$route.name] || audioMap.default
      this.sound_effect = new Audio(src)
    },

    audio_play () {
      if (!this.sound_effect) return

      if (!this.isPlayingAudio) {
        this.isPlayingAudio = true
        this.sound_effect.play()

        this.sound_effect.addEventListener('ended', () => {
          this.audio_stop()
        })
      }
    },

    audio_stop () {
      let self = this
      self.isPlayingAudio = false
      self.sound_effect.pause()
      self.sound_effect.currentTime = 0
    },

    // 錄音測試
    toggleRecord () {
      let self = this
      if (!self.isRecording) {
        self.startRecord()
      } else {
        self.clickStopRecord()
      }
    },

    startRecord () {
      let self = this
      if (!self.isRecording) {
        recorderJS = new Recorder()
        recorderJS.start().then(() => {
          self.drawRecord()
          self.isRecording = true
        }, (error) => {
          console.log(error)
          recorderJS.stop()

          self.isRecording = false
        })
      }
    },
    clickStopRecord () {
      let self = this

      recorderJS.stop()

      self.audioData = recorderJS.getWAVBlob()

      self.isRecording = false

      // self.playRecord()
    },
    stopRecord () {
      let self = this

      recorderJS.stop()

      self.isRecording = false
    },

    playRecord () {
      recorderJS.play()
    },

    drawRecord () {
      let self = this

      self.drawRecordId = requestAnimationFrame(self.drawRecord)
      self.drawWave({
        canvas: self.$refs.recordRefTest,
        dataArray: recorderJS.getRecordAnalyseData(),
        bgcolor: 'rgb(200, 200, 200, 0)',
        lineWidth: 2,
        lineColor: 'rgb(255, 255, 255)'
      })
    },

    drawWave({
      canvas,
      dataArray,
      bgcolor = 'rgb(200, 200, 200)',
      lineWidth = 2,
      lineColor = 'rgb(0, 0, 0)'
    }) {
      if (!canvas) return
      canvas.width = 140;
      canvas.height = 140;

      let background = new Image()
      background.src = require('@/assets//image/toeic/toeic_exam/recording_img2.png')
      background.size = 'contain'

      const ctx = canvas.getContext('2d')
      const bufferLength = dataArray.length
      const sliceWidth = canvas.width / bufferLength
      let x = 0
      ctx.drawImage(background, 0, 0)
      ctx.fillStyle = bgcolor
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      ctx.lineWidth = lineWidth
      ctx.strokeStyle = lineColor

      ctx.beginPath()

      for (let i = 0; i < bufferLength; i++) {
        const v = dataArray[i] / 128
        const y = (v * canvas.height) / 2

        if (i === 0) {
          ctx.moveTo(x, y)
        } else {
          ctx.lineTo(x, y)
        }
        x += sliceWidth
      }

      ctx.lineTo(canvas.width, canvas.height / 2)
      ctx.stroke()
    }
  }
}
</script>
<style lang="scss" scoped>
.max-w-xl { max-width: 36rem; }
.item_img {
  max-width: 155px;
  max-height: 155px;
}
.record_img {
  width: 140px;
  height: 140px;
  background-image: url('~@/assets//image/toeic/toeic_exam/recording_img2.png');
  background-size: 140px;
}
.canvas_test {
  width: 100%;
  height: 100%;
  max-width: 140px;
  max-height: 140px;
}
</style>
